import { Pipe, PipeTransform } from '@angular/core'
import { saleLocation } from './utils/sale.util'

/** 'BAUCHI, Alkaleri' -> 'Alkaleri, Bauchi' (see saleLocation). Pure, so it runs once per value. */
@Pipe({
  name: 'saleLocation',
})
export class SaleLocationPipe implements PipeTransform {
  transform(location: string | null | undefined): string {
    return saleLocation(location)
  }
}
